import { render } from "./ItemDetail.vue?vue&type=template&id=f6deda52"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"

import "./ItemDetail.vue?vue&type=style&index=0&id=f6deda52&lang=css"
script.render = render

export default script